import { createAction, props } from '@ngrx/store';

const prefix = '[Homebattery Advice Capacity]';

export const calculateBatteryCapacity = createAction(
  `${prefix} Calculate battery capacity`
);

export const setCalculatedBatteryCapacity = createAction(
  `${prefix} Set calculated battery capacity`,
  props<{
    calculatedBatteryCapacity: number | null;
  }>()
);
